<template>
    <div
        class="p-1 gap-x-2 flex items-center text-gray-200 hover:text-purple transition-all cursor-pointer"
        @click="logout"
    >
        <LogoutIcon />

        <div class="text-xs uppercase">
            log out
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

import LogoutIcon from '@/components/icons/LogoutIcon.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'

import { ROUTES } from '@/constants/routes'

const authorizationStore = useAuthorizationStore()

const router = useRouter()

async function logout() {
    const { success } = await authorizationStore.logout()

    if (success) {
        router.push({ name: ROUTES.authLogin })
    }
}
</script>
